module.exports = __webpack_public_path__ + "static/img/yongxin.453a0b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultrue/yongxin.png
// module id = 7yY/
// module chunks = 1